"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "posta": {
    "8b09710c": [{
      "hkey": "77ebcfef",
      "slug": "posta",
      "name": "Posta",
      "primary": true,
      "skipSearch": false
    }],
    "case-mariani": [{
      "hkey": "77ebcfef",
      "slug": "posta",
      "name": "Posta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3a1e1a5": [{
      "hkey": "94a67982",
      "slug": "fontarello-picciame",
      "name": "Fontarello-Picciame",
      "primary": true,
      "skipSearch": false
    }],
    "fontarello": [{
      "hkey": "94a67982",
      "slug": "fontarello-picciame",
      "name": "Fontarello-Picciame",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d3bd0b2d": [{
      "hkey": "8ac3f43f",
      "slug": "cerqua",
      "name": "Cerqua",
      "primary": true,
      "skipSearch": false
    }],
    "la-cergua": [{
      "hkey": "8ac3f43f",
      "slug": "cerqua",
      "name": "Cerqua",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c960f3ad": [{
      "hkey": "94a67982",
      "slug": "fontarello-picciame",
      "name": "Fontarello-Picciame",
      "primary": true,
      "skipSearch": false
    }],
    "pacciame": [{
      "hkey": "94a67982",
      "slug": "fontarello-picciame",
      "name": "Fontarello-Picciame",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "posta"
    }],
    "f02ef8f0": [{
      "hkey": "77ebcfef",
      "slug": "posta",
      "name": "Posta",
      "primary": true,
      "skipSearch": false
    }],
    "steccato": [{
      "hkey": "77ebcfef",
      "slug": "posta",
      "name": "Posta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;